import { motion } from "framer-motion";
import { BENEFITS } from "@/data/content";

const WhyChooseSection = () => {
    return (
        <section id="why-choose" data-testid="why-choose-section" className="relative bg-[#F8F5EE] py-24 sm:py-28">
            <div className="mx-auto max-w-7xl px-5 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 26 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7 }}
                    className="mx-auto max-w-3xl text-center"
                >
                    <div className="flex items-center justify-center gap-4">
                        <span className="gold-hairline h-px w-14" />
                        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#9E6D18]">The Standard We Stand On</p>
                        <span className="gold-hairline h-px w-14" />
                    </div>
                    <h2 data-testid="why-choose-heading" className="mt-6 font-display text-3xl font-bold tracking-tight text-[#1A1D24] sm:text-4xl lg:text-5xl">
                        Come Connect With <span className="text-gold-gradient">BrothaTruth</span>
                    </h2>
                </motion.div>

                <div className="mt-16 grid gap-10 sm:grid-cols-2 lg:grid-cols-5 lg:gap-6">
                    {BENEFITS.map((benefit, i) => (
                        <motion.div
                            key={benefit.title}
                            data-testid={`benefit-${benefit.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.6, delay: i * 0.1 }}
                            className="group text-center"
                        >
                            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full border border-[#D9A441]/50 bg-white shadow-[0_10px_30px_-12px_rgba(217,164,65,0.5)] transition-transform duration-500 group-hover:scale-110 group-hover:rotate-6">
                                <benefit.icon className="h-7 w-7 text-[#9E6D18]" strokeWidth={1.6} />
                            </div>
                            <h3 className="mt-5 font-display text-sm font-bold uppercase tracking-[0.18em] text-[#1A1D24]">
                                {benefit.title}
                            </h3>
                            <p className="mt-3 text-sm leading-relaxed text-[#1A1D24]/60">{benefit.description}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WhyChooseSection;
